import {useState} from 'react';
import {PortableTextWrapper} from '~/components';

// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Transition} from '@headlessui/react';
import {Heading, Text, IconAdd} from '~/components';
import type {SanityProductPage} from '~/types/sanityTypes';
import useSanityData from '~/lib/useSanityData';

export function ProductExtraData({
  sanityProduct: serverProduct,
  className = '',
  sanityQuery,
  sanityParams,
}: {
  sanityProduct?: SanityProductPage;
  className?: string;
  sanityQuery: string;
  sanityParams: {slug: string};
}) {
  const [featuresOpen, setFeaturesOpen] = useState(true);
  const [techOpen, setTechOpen] = useState(false);

  if (!serverProduct) {
    return null;
  }

  const sanityProduct: SanityProductPage = useSanityData(
    serverProduct,
    sanityQuery,
    sanityParams,
  );

  return (
    <div className={`bg-bgLight grid grid-cols-1 ${className}`}>
      <div className="container-narrow py-8 md:py-16">
        {(sanityProduct?.productAwards || sanityProduct?.productFeatures) && (
          <div className="pb-8">
            <div
              className="flex flex-row justify-between items-center cursor-pointer"
              onClick={() => setFeaturesOpen(!featuresOpen)}
            >
              <Heading as="h2" format>
                Tuotetiedot
              </Heading>
              <IconAdd
                className={`transition-all duration-75 ${
                  featuresOpen ? 'rotate-45' : ''
                }`}
              />
            </div>
            <Transition
              show={featuresOpen}
              enter="transition-opacity duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="pt-10 transition-all duration-75 overflow-hidden">
                {sanityProduct.productFeatures && (
                  <PortableTextWrapper blocks={sanityProduct.productFeatures} />
                )}
              </div>
            </Transition>
          </div>
        )}
        {sanityProduct?.technicalSpecs && (
          <div
            className={`pb-8 pt-8 ${
              sanityProduct?.productAwards ? 'border-t border-dividerDark' : ''
            }`}
          >
            <div
              className="flex flex-row justify-between items-center cursor-pointer"
              onClick={() => setTechOpen(!techOpen)}
            >
              <Heading as="h2" format>
                Tekniset tiedot
              </Heading>
              <IconAdd
                className={`transition-all duration-75 ${
                  techOpen ? 'rotate-45' : ''
                }`}
              />
            </div>
            <Transition
              show={techOpen}
              enter="transition-opacity duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="pt-4 duration-75 overflow-hidden">
                {sanityProduct.technicalSpecs?.map((group) => {
                  return (
                    <div className="pt-4 pb-4" key={group._key}>
                      {group.technicalSpecGroupLabel && (
                        <Heading
                          as="h4"
                          className="border-b border-dividerDark py-2 w-full max-w-full"
                        >
                          {group.technicalSpecGroupLabel}
                        </Heading>
                      )}

                      {group.technicalSpecLines.map((line) => {
                        return (
                          <div
                            key={line._key}
                            className="border-b border-divider py-2 grid grid-cols-2"
                          >
                            <Text as="div" className="font-bold">
                              {line.label}
                            </Text>
                            <Text as="div">{line.text}</Text>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </Transition>
          </div>
        )}
      </div>
    </div>
  );
}
